import { SelectOptionType } from '@octano/global-ui';
import { Control, Controller } from 'react-hook-form';
import { FormGroup, Input, Label } from 'reactstrap';

interface RadioInputProps {
  control: Control<any>;
  name: string;
  label: string;
  options: SelectOptionType[];
  rules?: any;
  disabled?: boolean;
}

/**
 * Campo de opción única (radio) para el DynamicForm.
 *
 * No existe un componente de radio en `@octano/global-ui`, por lo que se
 * implementa con react-hook-form + reactstrap. Guarda el `value` primitivo de
 * la opción seleccionada (consistente con cómo `evaluateCondition` resuelve los
 * condicionales).
 */
export default function RadioInput({
  control,
  name,
  label,
  options,
  rules,
  disabled,
}: RadioInputProps) {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
        const resolvedValue =
          value && typeof value === 'object' && 'value' in value
            ? value.value
            : value;

        return (
          <FormGroup tag="fieldset" className="mb-0">
            {label && <Label className="text-uppercase fw-600">{label}</Label>}
            {options.map((option) => {
              const optionId = `${name}-${option.value}`;
              return (
                <FormGroup check key={String(option.value)}>
                  <Input
                    type="radio"
                    id={optionId}
                    name={name}
                    checked={String(resolvedValue) === String(option.value)}
                    onChange={() => onChange(option.value)}
                    onBlur={onBlur}
                    disabled={disabled}
                  />
                  <Label check for={optionId}>
                    {option.label}
                  </Label>
                </FormGroup>
              );
            })}
            {error?.message && (
              <div className="text-danger g-input-error">{error.message}</div>
            )}
          </FormGroup>
        );
      }}
    />
  );
}
